package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.FormatStrikethroughW500Rounded: ImageVector
    get() {
        if (_formatStrikethroughW500Rounded != null) {
            return _formatStrikethroughW500Rounded!!
        }
        _formatStrikethroughW500Rounded = Builder(name = "FormatStrikethroughW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(111.87f, 562.15f)
                quadToRelative(-17.0f, 0.0f, -28.5f, -11.62f)
                reflectiveQuadToRelative(-11.5f, -28.62f)
                quadToRelative(0.0f, -17.0f, 11.57f, -28.5f)
                reflectiveQuadToRelative(28.67f, -11.5f)
                horizontalLineToRelative(736.02f)
                quadToRelative(17.0f, 0.0f, 28.5f, 11.5f)
                reflectiveQuadToRelative(11.5f, 28.5f)
                quadToRelative(0.0f, 17.0f, -11.57f, 28.62f)
                quadToRelative(-11.57f, 11.62f, -28.67f, 11.62f)
                lineTo(111.87f, 562.15f)
                close()
                moveTo(414.5f, 401.91f)
                verticalLineToRelative(-119.28f)
                lineTo(257.13f, 282.63f)
                quadToRelative(-27.39f, 0.0f, -46.33f, -19.05f)
                quadToRelative(-18.93f, -19.06f, -18.93f, -46.45f)
                quadToRelative(0.0f, -27.39f, 18.93f, -46.33f)
                quadToRelative(18.94f, -18.93f, 46.33f, -18.93f)
                horizontalLineToRelative(445.74f)
                quadToRelative(27.39f, 0.0f, 46.33f, 18.93f)
                quadToRelative(18.93f, 18.94f, 18.93f, 46.33f)
                quadToRelative(0.0f, 27.39f, -18.93f, 46.45f)
                quadToRelative(-18.94f, 19.05f, -46.33f, 19.05f)
                lineTo(545.74f, 282.63f)
                verticalLineToRelative(119.28f)
                lineTo(414.5f, 401.91f)
                close()
                moveTo(414.5f, 642.15f)
                horizontalLineToRelative(131.24f)
                verticalLineToRelative(100.48f)
                quadToRelative(0.0f, 27.29f, -19.06f, 46.4f)
                quadToRelative(-19.05f, 19.1f, -46.44f, 19.1f)
                quadToRelative(-27.39f, 0.0f, -46.57f, -19.17f)
                quadToRelative(-19.17f, -19.18f, -19.17f, -46.57f)
                verticalLineToRelative(-100.24f)
                close()
            }
        }
        .build()
        return _formatStrikethroughW500Rounded!!
    }

private var _formatStrikethroughW500Rounded: ImageVector? = null
